/**
 * Converts Microsoft Word highlight color names to hex values
 * Word uses w:highlight with w:val containing color names like "yellow", "green", etc.
 */
export const useWordHighlightColorToHex = (colorName: string | null): string | null => {
  if (!colorName) return null;
  
  const colorMap: Record<string, string> = {
    black: "#000000",
    blue: "#0000FF",
    cyan: "#00FFFF",
    darkBlue: "#000080",
    darkCyan: "#008080",
    darkGray: "#808080",
    darkGreen: "#008000",
    darkMagenta: "#800080",
    darkRed: "#800000",
    darkYellow: "#808000",
    green: "#00FF00",
    lightGray: "#C0C0C0",
    magenta: "#FF00FF",
    red: "#FF0000",
    white: "#FFFFFF",
    yellow: "#FFFF00",
  };
  
  const normalizedColor = colorName.toLowerCase();
  return colorMap[normalizedColor] || null;
};

